/* eslint-disable react/forbid-elements */
/* eslint-disable react/jsx-props-no-spreading */
import React, {FC} from 'react';

import {CommentAnnotationModel} from '../../../../../libs/shared/core/src/models/api/annotationModel';
import {LinkTrap} from '../../../../../libs/shared/ui/src/components/links/linkTrap';
import {LinkTooltips} from '../../../../../libs/shared/ui/src/components/tooltips/linkTooltips';
import {
  MarkdownRenderer,
  MarkdownRendererProps,
} from '../../../../../srcCommon/formatters/markdown/markdownRenderer';

interface DomMarkdownRendererProps extends MarkdownRendererProps<CommentAnnotationModel> {
  className?: string;
  onTrackLink?: (link: string, shiftKey?: boolean) => void;
}

export const DomMarkdownRenderer: FC<DomMarkdownRendererProps> = (props) => {
  // Web relies on linktrap to automatically handle any click on links so we don't need to pass this to the renderer.
  const {onTrackLink, className, ...otherProps} = props;

  return (
    <LinkTooltips className={className}>
      <LinkTrap onTrack={onTrackLink}>
        <MarkdownRenderer {...otherProps} />
      </LinkTrap>
    </LinkTooltips>
  );
};
